export default {
  users: (state) => state.users,
  editingUser: (state) => state.editingUser,
  loading: (state) => state.loading,
  allAgencies: (state) => state.allAgencies,
  allRoles: (state) => state.allRoles,
  page: (state) => state.page,
  sortBy: (state) => state.sortBy,
  orderBy: (state) => state.orderBy,
  search: (state) => state.search,
};
